//#region ng
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
//#endregion

//#region mat
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
//#endregion

//#region modules
// import { CorMatComponentsModule } from '../../_components/_mat/cor-mat-components.module';
import { CorDirectivesModule } from '../../_shared/_core/_ng/_directives/cor-directives.module';
//#endregion

//#region components
import { SetorFormModal } from '..';
//#endregion

@NgModule({
  imports: [
    // CorMatComponentsModule,
    CorDirectivesModule,
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
  ],
  declarations: [
    SetorFormModal,
  ],
  exports: [
    SetorFormModal,
  ],
})
export class SetorFormModalModule { }
